export const PRODUCTS = {
  Curtains: {
    blurb: "Made-to-measure drapes on tracks or rods.",
    styles: [
      { name: "S-Fold (Wave)", base: 520 },
      { name: "Pinch Pleat", base: 580 },
      { name: "Eyelet", base: 420 },
    ],
    hardware: [
      { name: "Standard Track", add: 0 },
      { name: "Roman Rod", add: 120 },
      { name: "Motorized Smart Track", add: 550, note: "Google Home / Alexa" },
    ],
    tierLabel: "Fabric Tier",
    tiers: [
      { name: "Essential", mult: 1, note: "Poly-linen looks" },
      { name: "Premium", mult: 1.35, note: "Linen blends, textured weaves" },
      { name: "Designer", mult: 1.8, note: "Belgian linen, designer houses" },
    ],
    fnLabel: "Function",
    functions: [
      { name: "Sheer", mult: 0.85 },
      { name: "Blockout", mult: 1 },
      { name: "Double Layer", mult: 1.75, note: "Sheer + blockout" },
    ],
  },
  Blinds: {
    blurb: "Roller, roman and venetian blinds.",
    styles: [
      { name: "Roller", base: 260 },
      { name: "Roman", base: 420 },
      { name: "Timber Venetian", base: 380 },
      { name: "Vertical", base: 240 },
    ],
    hardware: [
      { name: "Child-Safe Chain", add: 0 },
      { name: "Spring / Cordless", add: 60 },
      { name: "Motorized", add: 420, note: "Rechargeable, app control" },
    ],
    tierLabel: "Fabric Tier",
    tiers: [
      { name: "Essential", mult: 1 },
      { name: "Premium", mult: 1.3 },
      { name: "Designer", mult: 1.7 },
    ],
    fnLabel: "Function",
    functions: [
      { name: "Light Filtering", mult: 0.9 },
      { name: "Blockout", mult: 1 },
      { name: "Dual (Day / Night)", mult: 1.7 },
    ],
  },
  Shutters: {
    blurb: "Plantation shutters, custom finished.",
    styles: [
      { name: "Hinged Plantation", base: 780 },
      { name: "Bi-fold", base: 920 },
      { name: "Sliding", base: 980 },
    ],
    hardware: [
      { name: "Standard Tilt Rod", add: 0 },
      { name: "Hidden Tilt Rod", add: 60 },
      { name: "Motorized Louvres", add: 650 },
    ],
    tierLabel: "Finish",
    tiers: [
      { name: "Standard White", mult: 1 },
      { name: "Custom Colour", mult: 1.15 },
      { name: "Stained Timber", mult: 1.3 },
    ],
    fnLabel: "Material",
    functions: [
      { name: "PVC", mult: 1, note: "Wet-area safe" },
      { name: "Basswood", mult: 1.3 },
      { name: "Aluminium", mult: 1.5, note: "Outdoor rated" },
    ],
  },
};

export const SIZES = [
  { name: "Small", desc: "Under 1.2m wide", mult: 0.7 },
  { name: "Medium", desc: "1.2 – 2.4m wide", mult: 1 },
  { name: "Large", desc: "2.4 – 4m wide", mult: 1.6 },
  { name: "Floor-to-Ceiling", desc: "Over 4m or full-height", mult: 2.3 },
];

export const ADDONS = [
  { name: "Professional Installation", perWindow: 120, desc: "Fitted, levelled & child-safety certified" },
  { name: "Old Blind Removal", perWindow: 35, desc: "Take-down and responsible disposal" },
];

export const calcEstimate = (s) => {
  const p = PRODUCTS[s.product];
  if (!p || !s.style || !s.hardware || !s.tier || !s.fn || !s.size) return null;
  const style = p.styles.find((x) => x.name === s.style);
  const hw = p.hardware.find((x) => x.name === s.hardware);
  const tier = p.tiers.find((x) => x.name === s.tier);
  const fn = p.functions.find((x) => x.name === s.fn);
  const size = SIZES.find((x) => x.name === s.size);
  const addons = ADDONS.filter((a) => s.addons.includes(a.name)).reduce((t, a) => t + a.perWindow, 0);
  const perWindow = style.base * tier.mult * fn.mult * size.mult + hw.add + addons;
  const total = perWindow * s.windows;
  const round = (n) => Math.round(n / 10) * 10;
  return { low: round(total * 0.88), high: round(total * 1.15), perWindow: round(perWindow) };
};

export const fmt = (n) => `A$${n.toLocaleString("en-AU")}`;
